<script>
import {ElNotification} from "element-plus";
import store from "../../store";

export default {
  name: 'ReestrEditForm',
  computed: {
    store() {
      return store
    },
  },
  props: {
    initiative: {
      type: String,
      required: true
    },
    initiativeDetail: {
      type: Object,
      required: true
    },
    initiativeCategoryId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      loadingCategory: false,
      dialogVisible: false,
      initiativeId: null,
      initiativeTable: [],
      productsList: [],
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      categories: [],
      isError: false,
      activeCategory: null,
      rules: {
        granted_price: [{required: true, message: 'req', trigger: 'blur'}],
      },
      totalGrantedPrice: 0
    }
  },
  methods: {
    onClickAddProduct(category, product) {
      let hasCategoryIndex = this.productsList.findIndex(it => it.category_id === category.id);
      if (hasCategoryIndex !== -1) {
        let hasProduct = this.productsList[hasCategoryIndex].products.findIndex(p => p.id === product.id);
        if (hasProduct === -1) {
          this.productsList[hasCategoryIndex].products.push({...product, count: 0, granted_count: 0, granted_price: 0})
        } else {
          ElNotification.warning("Ushbu maxsulot qo'shilgan");
        }
      } else {
        this.productsList.push({
          category_id: category.id,
          name: category.title,
          products: [{...product, count: 0, granted_price: 0, granted_count: 0}]
        })
      }
      setTimeout(() => {
        const element = document.getElementById("tableWrapper");
        element.scrollTo({
          top: element.clientHeight,
          behavior: "smooth"
        });
      }, 0)
    },

    onClickReestrEdit() {
      this.dialogVisible = true;
      this.initiativeId = this.initiative;
      this.getInitiativeById();
    },

    getInitiativeById() {
      this.loading = true;
      this.$http
          .get(`api/v1/moderators/products/initiatives/${this.initiativeId}`)
          .then(({data}) => {
            this.initiativeTable = data;
            let tempCategories = [...new Set(this.initiativeTable.products.map((product) => product.category_id + '****' + product.category))]

            this.productsList = tempCategories.map(category => {
              return {
                category_id: parseFloat(category.split('****')[0]),
                name: category.split('****')[1],
                products: this.initiativeTable.products.filter(product => {
                  return product.category_id === parseFloat(category.split('****')[0])
                })
              }
            });
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          })
          .finally(() => this.loading = false);
    },

    onSubmit() {
      this.loading = true;
      let tempForm = [];
      this.productsList.forEach(category => {
        category?.products.forEach(product => {
          tempForm.push({
            id: product.id,
            granted_price: parseFloat(product.granted_price.replace(/\s/g, "")),
            granted_count: parseFloat(product.granted_count),
            price: parseFloat(product.price.replace(/\s/g, "")),
            count: parseFloat(product.count)
          })
        })
      });

      this.totalGrantedPrice = tempForm.reduce((sum, item) => {
        return sum + (item.granted_price || 0) * (item.granted_count || 0);
      }, 0);

      this.loading = false;
      switch (this.initiativeDetail.type) {
        case "EQUIPMENT":
          if (this.totalGrantedPrice <= this.initiativeDetail.board.equipment_initiatives_max_amount) {
            this.addProductsToInitiative(tempForm);
          } else {
            this.isError = true
            ElNotification.error({
              message: `Ma'qullangan mablag' ${this.getPriceFormat(this.initiativeDetail.board.equipment_initiatives_max_amount)} so'mdan oshib ketti`,
            });
          }
          break;
        case "CONSTRUCTION":
          if (this.totalGrantedPrice <= this.initiativeDetail.board.initiatives_max_amount) {
            this.addProductsToInitiative(tempForm);
          } else {
            this.isError = true
            ElNotification.error({
              message: `Ma'qullangan mablag' ${this.getPriceFormat(this.initiativeDetail.board.initiatives_max_amount)} so'mdan oshib ketti`,
            });
          }
          break;
      }
    },

    addProductsToInitiative(form) {
      this.isError = false
      this.$http
          .post(
              `api/v1/moderators/products/initiatives/${this.initiativeId}`,
              form
          )
          .then(() => {
            ElNotification.success({
              message: "Ma'qullash bajarildi.",
            });
            this.dialogVisible = false;
            this.$emit('getInitiative')
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onClickNewProduct() {
      this.loadingCategory = true;
      this.categories = [];
      this.getCategories();
    },

    getCategories() {
      this.$http
          .get(
              `api/v1/product-categories?initiative_category_id=${this.initiativeCategoryId}`)
          .then(({data}) => {
            this.categories = data['product_categories'];
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Maxsulotlarni yuklashda xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loadingCategory = false;
          });
    },

    onChangeCategory() {
      let hasCategory = false;
      this.categories.forEach(category => {
        if (category.id === this.activeCategory[this.activeCategory.length - 1] && category.products?.length) {
          hasCategory = true;
        }
      })
      if (!hasCategory) {
        this.getProductsByCategory();
      }
    },

    getProductsByCategory() {
      let categoryId = this.activeCategory[this.activeCategory.length - 1];
      if (categoryId) {
        this.$http
            .get(
                `api/v1/products?category_id=${categoryId}`)
            .then(({data}) => {
              this.categories.map(category => {
                if (categoryId === category.id) {
                  category.products = data.products
                }
                return category
              })
            })
            .catch((error) => {
              ElNotification.error({
                message:
                    error.response.data.message ||
                    "Maxsulotlarni yuklashda xatolik sodir bo'ldi!",
              });
            })
            .finally(() => {
              this.loadingCategory = false;
            });
      }
    },

    onClickRemove(c_id, c_index, p_id, p_index) {
      let categoryIndex = this.productsList.findIndex(item => item.category_id === c_id);
      if (p_index === 0 && this.productsList[categoryIndex].products.length === 1) {
        this.productsList.splice(c_index, 1)
      } else {
        if (categoryIndex !== -1) {
          this.productsList[categoryIndex].products.splice(p_index, 1);
        }
      }
    },

    getPriceFormat (price) {
      return new Intl.NumberFormat('ru-RU').format(price).replace(/,/g, ',')
    }
  }
}
</script>

<template>
  <el-button type="warning" style="margin-right: 12px" @click="onClickReestrEdit">Restrni tahrirlash</el-button>
  <el-dialog
      v-model="dialogVisible"
      width="80%"
      top="10px"
      title="Reestirni tahrirlash"
  >
    <div style="" class="content-table-wrapper" v-loading="loading">
      <el-form
          ref="acceptForm"
          :model="productsList"
          :rules="rules"
          label-position="top"
          style="width: 100%;min-height: 540px;overflow-x: scroll;display: flex;flex-direction: column;justify-content: space-between;"
      >
        <div class="table-wrapper" id="tableWrapper">
          <table class="content-table" v-if="productsList?.length">
            <thead>
            <tr style="font-family: 'Montserrat-Bold',sans-serif">
              <th style="white-space: nowrap">Жиҳоз номи</th>
              <th style="white-space: nowrap">Ўлчов бирлиги</th>
              <th style="white-space: nowrap">Нарҳи</th>
              <th style="white-space: nowrap">Мақулланган маблағ</th>
              <th style="white-space: nowrap">Мақулланган Сони</th>
              <th style="white-space: nowrap">Сони</th>
              <th style="white-space: nowrap">Қиймати</th>
              <th v-if="store.state.role!=='moderator'"></th>
            </tr>
            </thead>
            <tbody>
            <template
                v-for="(category,c_index) in productsList"
                :key="category"
            >
              <tr>
                <td
                    class="product-item"
                    style="font-family: 'Montserrat-Bold', sans-serif;
                background: rgba(128, 128, 128, 0.1)"
                    colspan="8"
                >
              <span>
                {{ category.name }}
              </span>
                </td>
              </tr>

              <tr
                  v-for="(product,p_index) in category.products"
                  :key="product.id"
              >
                <td class="product-item">{{ product.title }}</td>
                <td class="product-item">
                  {{
                    product.unit_of_measure === 'collection' ? 'Тўплам' : product.unit_of_measure === 'package' ? 'Қути' : 'Дона'
                  }}
                </td>


                <td class="product-item">
                  <el-form-item>
                    <input class="custom-input" v-model="product.price" v-money="money"/>
                  </el-form-item>
                </td>
                <td class="product-item">
                  <el-form-item>
                    <input class="custom-input" v-model="product.granted_price" v-money="money"/>
                  </el-form-item>
                </td>
                <td class="product-item">
                  <el-form-item>
                    <el-input-number v-model="product.granted_count" :min="0" :max="product.max_available"/>
                  </el-form-item>
                </td>
                <td class="product-item">
                  <span style="display:block;color: #0A194E; font-weight: 700;text-align: center">{{
                      product.count
                    }}</span>
                  <!--                    <el-input-number v-model="product.count" :min="1" :max="product.max_available"/>-->
                </td>

                <td class="product-item" style="min-width: 200px">
                  <span style="color: #000000; font-weight: 700;">
                     {{
                      product.granted_price.length && new Intl.NumberFormat('ru-RU').format(product.granted_count * parseFloat(product.granted_price.replace(/\s/g, ""))).replace(/,/g, ',')
                    }}
                  </span>
                </td>
                <td class="product-item" style="padding:10px 10px 0 10px" v-if="store.state.role!=='moderator'">
                  <img @click="onClickRemove(category.category_id,c_index,product.id,p_index)"
                       style="margin-top: 4px;cursor: pointer"
                       width="20"
                       src="../../assets/images/icons/cross-icon.svg" alt="-"/>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>

        <el-form-item>
          <el-row :gutter="20" style="width: 100%;margin: 12px 0 0;">
            <el-col :span="6" style="padding: 0">
              <el-button type="warning" @click="onClickNewProduct">+ Yangi tovar qo'shish</el-button>
            </el-col>
            <el-col :span="18" align="right" style="padding: 0;" v-if="productsList?.length">
              <div v-if="totalGrantedPrice > 0" class="approved-funds">
                Ma'qullangan mablag':
                <span :class="isError ? 'text-error' : 'text-success'">{{ getPriceFormat(totalGrantedPrice) }} so'm</span>
              </div>
              <el-button @click="dialogVisible=false">Yopish</el-button>
              <el-button type="primary" :disabled="loading" @click="onSubmit">Saqlash</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div class="new-products" v-loading="loadingCategory">
      <el-collapse v-model="activeCategory" @change="onChangeCategory">
        <template v-for="category in categories" :key="category.id">
          <el-collapse-item style="font-family: 'Montserrat-Bold', sans-serif"
                            :title="category.title"
                            :name="category.id">
            <div class="products" v-if="category.products?.length">
              <div class="product-item" v-for="product in category.products" :key="product.id">
                <span>{{ product.title }}</span>
                <el-button type="primary" @click="onClickAddProduct(category,product)">+</el-button>
              </div>
            </div>
          </el-collapse-item>
        </template>
      </el-collapse>
      <el-empty v-if="!categories.length" image-size="40" description="Kategoriya ma'lumotlari yo'q"/>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
:deep(.table-wrapper) {
  max-height: calc(100vh - 500px);
  overflow: auto;
}

.content-table {
  width: 100%;
  border-collapse: collapse;

  &-wrapper {
    width: 100%;
    scrollbar-width: thin;
    scrollbar-color: rgba(105, 116, 131, 0.3) #ffff;

    &::-webkit-scrollbar-track {
      background-color: #a0a0a019;
    }

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      scrollbar-width: thin;
      scrollbar-color: rgba(105, 116, 131, 0.3);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(105, 116, 131, 0.3);
    }
  }

  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 5px;
    font-size: 13px;
  }
}

:deep(.el-input-number__decrease), :deep(.el-input-number__increase) {
  background-color: #f5f5f5;
  color: #081f27;
  border: none;

  &.is-disabled {
    color: #d7d5d5;
  }
}

:deep(.el-input__wrapper) {
  box-shadow: none;
}

.custom-input {
  border: none;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;

  &:focus-visible {
    border: none;
    outline: none;
  }
}

.new-products {
  margin-top: 20px;
  height: 250px;
  overflow: auto;
}

.products {
  padding: 5px 20px;
  background-color: #fbf9f9;

  .product-item {
    font-family: "Montserrat", sans-serif;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
    color: #000000;
  }
}

.approved-funds {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  margin-right: 8px;
}

.text-error {
  color: red;
}

.text-success {
  color: green;
}
</style>
